















































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import AppConsts from "@/lib/appconst";
import CreateSalesOrderLineDto from "../../../store/entities/sales-orders/create-sales-order-line";
import CreateSalesOrderDto from "../../../store/entities/sales-orders/create-sales-order";
import Customer from "../../../store/entities/customers/customer";
import columns from "./create-sales-order-line-columns";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import ProductForSelect from "@/store/entities/products/product-for-select";
import _ from "lodash";

class PageSalesOrderLineRequest extends PageRequest {
  sku: string;
}
@Component({
  components: { AddressModal, "vue-editor":  VueEditor },
})
export default class CreateSalesOrder extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  addressModalShow: boolean = false;
  pagerequest: PageSalesOrderLineRequest = new PageSalesOrderLineRequest();
  salesOrder: CreateSalesOrderDto = new CreateSalesOrderDto();
  salesOrderLines: Array<CreateSalesOrderLineDto> = new Array<
    CreateSalesOrderLineDto
  >();
  salesOrderLinesPerPage: Array<CreateSalesOrderLineDto> = new Array<
    CreateSalesOrderLineDto
  >();
  filterTotalCount: number = 0;
  sku: string = "";
  qty: number = 1;
  customer: Customer = new Customer();
  customers: Array<Customer> = new Array<Customer>();
  customerKeyword: string = "";
  assetTypeCode: string = "";
  conditionTypeCode: string = "";
  spinShow: boolean = false;
  customerLoading: boolean = false;
  soSelectedAddress: Address = new Address();
  objectLoading: boolean = false;
  productName: string = "";
  products: Array<ProductForSelect> = new Array<ProductForSelect>();
  searchProduct_OnPress = _.debounce(
    this.searchProductForSelect,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  searchCustomer_OnPress = _.debounce(
    this.searchCustomers,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  get clientCode() {
    return this.$store.state.session.client.code;
  }
  get bizTypes() {
    var re = this.$store.state.saleOrder.bizTypes;
    return re;
  }
  get shippingServices() {
    var re = this.$store.state.client.clientShippingServices;
    return re;
  }
  get outboundModes() {
    var re = this.$store.state.saleOrder.outboundModes;
    return re;
  }
  get warehouses() {
    var re = this.$store.state.warehouse.warehousesForSelect;
    return re;
  }
  get inventModels() {
    var re = this.$store.state.product.inventModels;
    return re;
  }
  get conditionTypes() {
    var re = this.$store.state.masterData.conditionTypes;
    this.conditionTypeCode = re.length === 0 ? "" : re[0].id;
    return re;
  }
  get assetTypes() {
    var re = this.$store.state.client.clientAssetTypes;
    this.assetTypeCode = re.length === 0 ? "" : re[0].id;
    return re;
  }

  updateAddress() {
    if (!Util.isNull(this.soSelectedAddress)) {
      this.salesOrder.shippingFullAddress = this.soSelectedAddress.fullAddress;
      this.salesOrder.shippingProvinceId = this.soSelectedAddress.provinceId;
      this.salesOrder.shippingDistrictId = this.soSelectedAddress.districtId;
      this.salesOrder.shippingWardId = this.soSelectedAddress.wardId;
      this.salesOrder.shippingAddressNo = this.soSelectedAddress.addressNo;
    } else {
      this.salesOrder.shippingFullAddress = "";
      this.salesOrder.shippingProvinceId = 0;
      this.salesOrder.shippingDistrictId = null;
      this.salesOrder.shippingWardId = null;
      this.salesOrder.shippingAddressNo = "";
    }
  }
  openModalAddress() {
    this.addressModalShow = true;
  }
  changeInventModel(value) {
    this.salesOrder.inventModel = value;
  }

  changeCustomer(val) {
    if (Util.isNull(this.customer.id)) {
      this.soSelectedAddress = null;
      this.salesOrder.customerCode = "";
      this.salesOrder.customerName = "";
      this.salesOrder.customerPhone = "";
      this.salesOrder.shippingFullAddress = "";
    } else {
      var selectedCustomer = this.customers.find(
        (i) => i.id === this.customer.id
      );
      this.customer = selectedCustomer;
      this.soSelectedAddress = this.customer.customerAddress;
      this.salesOrder.customerCode = this.customer.code;
      this.salesOrder.customerName = this.customer.name;
      this.salesOrder.customerPhone = this.customer.phone;
    }
    this.updateAddress();
  }
  async changeWarehouseCode() {
    this.resetList();
  }
  async searchCustomers(keyword) {
    if (Util.isEmpty(keyword)) return;
    this.customerLoading = true;
    this.customers = await this.$store.dispatch({
      type: "customer/searchCustomerForSelect",
      data: {
        keyWord: keyword,
      },
    });
    this.customerLoading = false;
  }
  async searchProductForSelect(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    this.products = await this.$store.dispatch({
      type: "product/searchProductForSelect",
      data: {
        clientCode: this.clientCode,
        keyWord: keyword,
      },
    });
    this.objectLoading = false;
  }
  changeProduct() {
    if (Util.isNull(this.sku) || Util.isEmpty(this.sku)) {
      this.productName = "";
      return;
    }
    var product = _.find(this.products, ["sku", this.sku]);
    if (Util.isNull(product)) {
      this.productName = "";
      Util.showErrorMsg(this, "Error.ProductNotExist");
      return;
    }
    this.productName = product.name;
  }
  async addProduct() {
    if (Util.isNull(this.sku) || Util.isEmpty(this.sku)) {
      Util.showErrorMsg(this, "Error.SkuRequired");
      return;
    }
    var items = this.salesOrderLines;
    var existedItems = items.filter(
      (item) =>
        item.sku === this.sku &&
        item.assetTypeCode === this.assetTypeCode &&
        item.conditionTypeCode === this.conditionTypeCode
    );
    if (existedItems.length > 0) {
      Util.showErrorMsg(this, "Error.SkuExisted");
      return;
    } else {
      this.spinShow = true;
      try {
        var product = await this.$store.dispatch({
          type: "product/checkClientProductInvBalBySku",
          data: {
            sku: this.sku.trim(),
            qty: this.qty,
            clientCode: this.clientCode,
            warehouseCode: this.salesOrder.warehouseCode,
            customerCode: this.salesOrder.customerCode,
            assetTypeCode: this.assetTypeCode,
            conditionTypeCode: this.conditionTypeCode,
            markPreOrder: this.salesOrder.markPreOrder,
          },
        });
        if (!Util.isNull(product)) {
          var newLine = new CreateSalesOrderLineDto();
          newLine = {
            orderNo: 0,
            sku: product.sku,
            productName: product.name,
            productId: product.id,
            orderQty: this.qty,
            assetTypeCode: this.assetTypeCode,
            conditionTypeCode: this.conditionTypeCode,
            productPrice: product.price,
            price: 0,
            vatPercent: 0,
            configPrice: 0,
            warehouseCode: "",
            qty: 0,
          };
          this.salesOrderLines.push(newLine);
          this.pageSalesOrderLinesChange();
          this.sku = "";
          this.qty = 1;
        }
        this.spinShow = false;
      } catch (error) {
        this.spinShow = false;
      }
    }
  }
  async checkProductInvBal(row: any, index: number) {
    try {
      this.spinShow = true;
      var item = this.salesOrderLinesPerPage[index];
      var newValue = row.orderQty;

      if (
        Util.isNull(this.salesOrder.markPreOrder) ||
        !this.salesOrder.markPreOrder
      ) {
        var isEnough = await this.$store.dispatch({
          type: "product/checkClientProductInvBal",
          data: {
            sku: item.sku,
            productId: item.productId,
            qty: newValue,
            clientCode: this.clientCode,
            warehouseCode: this.salesOrder.warehouseCode,
            assetTypeCode: this.assetTypeCode,
            conditionTypeCode: this.conditionTypeCode,
          },
        });
        if (Util.isNull(isEnough) || !isEnough) {
          newValue = item.orderQty;
        }
      }

      this.salesOrderLinesPerPage[index].orderQty = newValue;
      var line = this.salesOrderLines.find(
        (i) => i.productId === item.productId
      );
      line.orderQty = newValue;
      row.orderQty = newValue;
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
  onchangeProductVatPercent(row: any, index: number) {
    var item = this.salesOrderLinesPerPage[index];
    var newValue = row.vatPercent;
    this.salesOrderLinesPerPage[index].vatPercent = newValue;
    var line = this.salesOrderLines.find((i) => i.productId === item.productId);
    line.vatPercent = newValue;
    row.vatPercent = newValue;
  }
  onchangeProductPrice(row: any, index: number) {
    var item = this.salesOrderLinesPerPage[index];
    var newValue = row.price;
    this.salesOrderLinesPerPage[index].price = newValue;
    var line = this.salesOrderLines.find((i) => i.productId === item.productId);
    line.price = newValue;
    row.price = newValue;
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreateSalesOrder"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          var lines = this.salesOrderLines.map((item) => {
            return {
              sku: item.sku,
              orderQty: item.orderQty,
              assetTypeCode: item.assetTypeCode,
              conditionTypeCode: item.conditionTypeCode,
              price: item.price,
              vatPercent: item.vatPercent,
            };
          });
          this.salesOrder.items = lines;
          this.salesOrder.clientCode = this.clientCode;
          await this.$store
            .dispatch({
              type: "saleOrder/create",
              data: this.salesOrder,
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.CreateSalesOrder");
              this.reset();
              this.onGoBack();
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  onGoBack() {
    this.$root.$router.push({ name: "saleorder" });
  }

  remove(index: number) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L(`Confirm.RemoveSalesOrderProduct`),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        var item = this.salesOrderLinesPerPage[index];
        var items = this.salesOrderLines.filter(
          (i) => i.productId != item.productId
        );
        this.salesOrderLines = items;
        await this.getpage();
      },
    });
  }

  reset() {
    this.pagerequest = new PageSalesOrderLineRequest();
    this.sku = "";
    this.qty = null;
    this.customer = null;
    this.customers = new Array<Customer>();
    this.customerKeyword = "";
    this.assetTypeCode = "";
    this.conditionTypeCode = "";
    this.customerLoading = false;
    this.soSelectedAddress = new Address();
    this.salesOrder = new CreateSalesOrderDto();
    this.salesOrderLines = new Array<CreateSalesOrderLineDto>();
    this.salesOrderLinesPerPage = new Array<CreateSalesOrderLineDto>();
    this.filterTotalCount = 0;
    this.productName = "";
    this.products = new Array<ProductForSelect>();
    this.objectLoading = false;
  }

  resetList() {
    if (this.salesOrderLines.length > 0) {
      this.$Modal.confirm({
        title: this.L("Tips"),
        content: this.L(`Confirm.ResetSalesOrderDetails`),
        okText: this.L("Yes"),
        cancelText: this.L("No"),
        onOk: async () => {
          this.salesOrderLines = new Array<CreateSalesOrderLineDto>();
          await this.getpage();
        },
      });
    }
  }

  // sale order line
  get list() {
    var re = this.salesOrderLinesPerPage;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }

  get loading() {
    return this.$store.state.saleOrder.loading;
  }

  pageChange(page: number) {
    this.$store.commit("saleOrder/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("saleOrder/setPageSize", pagesize);
    this.getpage();
  }

  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    this.pageSalesOrderLinesChange();
  }

  pageSalesOrderLinesChange() {
    var items = this.salesOrderLines;
    if (
      !Util.isNull(this.pagerequest.sku) &&
      !Util.isEmpty(this.pagerequest.sku)
    ) {
      items = items.filter(
        (item) => item.sku.indexOf(this.pagerequest.sku) >= 0
      );
    }
    this.filterTotalCount = items.length;
    this.salesOrderLinesPerPage = Util.pagingItems(
      items,
      this.pageSize,
      this.currentPage
    );
  }

  get pageSize() {
    return this.$store.state.saleOrder.pageSize;
  }

  get totalCount() {
    return this.filterTotalCount;
  }

  get currentPage() {
    return this.$store.state.saleOrder.currentPage;
  }

  async created() {
    this.spinShow = true;
    try {
      await this.$store
        .dispatch({
          type: "masterData/getFeatureConditionTypes",
          data: { featureCode: AppConsts.featureConditionType.SO_Create },
        })
        .then((result) => {
          var re = this.$store.state.masterData.conditionTypes;
          this.conditionTypeCode = re.length === 0 ? "" : re[0].id;
        });
      await this.$store.dispatch({
        type: "warehouse/getListForSelect",
      });
      await this.$store
        .dispatch({
          type: "saleOrder/getBizTypes",
        })
        .then((result) => {
          var re = this.$store.state.saleOrder.bizTypes;
          this.$set(
            this.salesOrder,
            "bizType",
            re.length === 0 ? "" : re[0].code
          );
        });
      await this.$store
        .dispatch({
          type: "saleOrder/getOutboundModes",
        })
        .then((result) => {
          var re = this.$store.state.saleOrder.outboundModes;
          this.$set(
            this.salesOrder,
            "outboundMode",
            re.length === 0 ? "" : re[0].code
          );
        });
      await this.$store.dispatch({
        type: "product/getListInventModelsForSelect",
        data: {
          tableName: AppConsts.tableRef.tableProduct.name,
          columnName: AppConsts.tableRef.tableProduct.column.inventModel,
        },
      });
      await this.$store
        .dispatch({
          type: "client/getClientAssetTypeServices",
          data: this.clientCode,
        })
        .then((result) => {
          var re = this.$store.state.client.clientAssetTypes;
          this.assetTypeCode = re.length === 0 ? "" : re[0].id;
        });
      await this.$store
        .dispatch({
          type: "client/getClientShippingServices",
          data: this.clientCode,
        })
        .then((result) => {
          var re = this.$store.state.client.clientShippingServices;
          this.$set(
            this.salesOrder,
            "shippingServiceCode",
            re.length === 0 ? "" : re[0].id
          );
        });
      this.customer.customerAddress = new Address();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }

  columns = columns;
  salesOrderRule = {
    warehouseCode: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Warehouse")),
        trigger: "blur",
      },
    ],
    bizType: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("BizType")),
        trigger: "blur",
      },
    ],
    shippingServiceCode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ShippingService")
        ),
        trigger: "blur",
      },
    ],
    outboundMode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("OutboundMode")
        ),
        trigger: "blur",
      },
    ],
    customerCode: [
      {
        required: true,
        type: "string",
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("CustomerCode")
        ),
        trigger: "blur",
      },
    ],
    customerName: [
      {
        required: true,
        type: "string",
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("CustomerName")
        ),
        trigger: "blur",
      },
    ],
    customerPhone: [
      {
        required: true,
        type: "string",
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("CustomerPhone")
        ),
        trigger: "blur",
      },
    ],
    shippingFullAddress: [
      {
        required: true,
        type: "string",
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ShippingAddress")
        ),
        trigger: "blur",
      },
    ],
  };
}
